// The About page, as a dialog the menu opens. It holds a line on what this
// is, with a link to the studio, and the credit for the spell icons. The
// icons come from game-icons.net under CC BY 3.0, and that license needs the
// authors named where a player can find them. If this page goes, the credit
// needs a new home. The rest is not written yet.

import { el } from '../lib/dom';
import { createCloseButton } from './CloseButton';
import { iconAuthors } from './SpellIcon';

const TITLE = 'About';
/** Garrett's line, 2026-10-10: "currently an experiment, brainfruit.studio". */
const STATUS_LINE = 'Currently an experiment, ';
const STUDIO_NAME = 'brainfruit.studio';
const STUDIO_URL = 'https://brainfruit.studio';
const ICON_SOURCE = 'game-icons.net';
const ICON_LICENSE = 'CC BY 3.0';

export type About = {
  root: HTMLDialogElement;
  open: () => void;
};

export const createAbout = (): About => {
  const page = el('section', { className: 'about' }, [
    el('h2', { className: 'about__title', textContent: TITLE }),
    el('p', { className: 'about__status' }, [
      STATUS_LINE,
      el('a', { href: STUDIO_URL, target: '_blank', rel: 'noopener', textContent: STUDIO_NAME }),
    ]),
    el('p', {
      className: 'about__credit',
      textContent: `Spell icons from ${ICON_SOURCE} by ${iconAuthors().join(', ')}, ${ICON_LICENSE}.`,
    }),
  ]);
  const root = el('dialog', { className: 'modal' }, [page]);
  page.append(createCloseButton(() => root.close()));

  // The dialog element is the whole screen. A click that lands on it, and not on the page, is outside.
  root.addEventListener('click', (event) => {
    if (event.target === root) root.close();
  });

  return {
    root,
    open: () => {
      if (!root.open) root.showModal();
    },
  };
};
